import { Button, Grid, TextField } from "@mui/material";
import Config from "../../Utils/Config";
import { ServiceFormSettingsValidationSchema } from "../../Utils/Models";
import { Controller, useForm } from "react-hook-form";
import { useContext, useEffect } from "react";
import { WebSocketContext } from "../../Context/WebSocketContext";
import { yupResolver } from "@hookform/resolvers/yup";
import { getData } from "../../Services/getData";
import { AxiosResponse } from "axios";
import { endpoints } from "../../Utils/UrlEnum";
import { putData } from "../../Services/putData";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Save } from "@mui/icons-material";
import styles from "../../Styles/settings.module.css";

export default function ServiceFormSettings() {
  const websocketContext = useContext(WebSocketContext);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(ServiceFormSettingsValidationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    context: undefined,
    shouldFocusError: true,
    shouldUnregister: false,
    criteriaMode: "firstError",
  });

  /**
   *
   * @param data
   */
  const onSubmit = (data: any) => {
    const newMethod = Object.assign({}, data);
    putData(endpoints.setting.serviceForm, newMethod).then((res: AxiosResponse) => {
      if (res?.data) {
        websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
        reset(res.data);
      }
    });
  };

  /**
   *
   */
  useEffect(() => {
    getData(endpoints.setting.serviceForm).then((res: AxiosResponse) => {
      if (res?.data) {
        reset(res.data);
      }
    });
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.settingsForm}>
      <Grid container spacing={Config.standardGridSpacing}>
        <Grid item xs={12} sm={12} md={12} lg={10.9}>
          <Controller
            name="value.serviceFormEmail"
            control={control}
            render={({ field: { value, onChange, ref } }) => (
              <TextField
                fullWidth
                label={Vocabulary.serviceFormEmail}
                value={value || ""}
                onChange={onChange}
                inputRef={ref}
                type="email"
                error={Boolean(errors?.value?.serviceFormEmail)}
                helperText={
                  errors?.value?.serviceFormEmail?.message ||
                  Vocabulary.serviceFormEmailDescription
                }
              />
            )}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={10}
          xl={1}
          className={styles.oblioSettingsButtonContainer}
        >
          <Button
            type="submit"
            fullWidth
            startIcon={<Save />}
            variant="contained"
          >
            {Vocabulary.save}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
